import Hls from 'hls.js';

// One player for the whole app: the station keeps playing while you move between pages.
const audio = typeof Audio !== 'undefined' ? new Audio() : null;
let hls = null;
const saved = (() => { try { return JSON.parse(localStorage.getItem('ops_radio') || '{}'); } catch { return {}; } })();
const state = { station: saved.station || null, playing: false, loading: false, error: null, volume: saved.volume ?? 0.6 };
const subs = new Set();
const emit = () => subs.forEach(f => f({ ...state }));
const persist = () => localStorage.setItem('ops_radio', JSON.stringify({ station: state.station, volume: state.volume }));

if (audio) {
  audio.volume = state.volume;
  audio.preload = 'none';
  audio.addEventListener('playing', () => { state.playing = true; state.loading = false; state.error = null; emit(); });
  audio.addEventListener('waiting', () => { state.loading = true; emit(); });
  audio.addEventListener('pause', () => { state.playing = false; state.loading = false; emit(); });
  audio.addEventListener('error', () => { state.playing = false; state.loading = false; state.error = 'Stream unavailable — try another station'; emit(); });
}

function load(url) {
  if (hls) { hls.destroy(); hls = null; }
  if (/\.m3u8(\?|$)/i.test(url) && Hls.isSupported()) {
    hls = new Hls({ enableWorker: true });
    hls.loadSource(url);
    hls.attachMedia(audio);
    hls.on(Hls.Events.ERROR, (_, d) => { if (d.fatal) { state.error = 'Stream unavailable — try another station'; state.loading = false; state.playing = false; emit(); } });
  } else if (/^http:\/\//i.test(url)) {
    // plain-http streams get relayed through our https backend (browsers block mixed content)
    audio.src = `${process.env.REACT_APP_BACKEND_URL}/api/boards/data/radio/stream?url=${encodeURIComponent(url)}&token=${encodeURIComponent(localStorage.getItem('token') || '')}`;
  } else {
    audio.src = url;
  }
}

export const radio = {
  subscribe(f) { subs.add(f); f({ ...state }); return () => subs.delete(f); },
  get() { return { ...state }; },
  play(station) {
    if (!audio || !station?.url) return;
    state.station = { name: station.name || station.label, url: station.url, favicon: station.favicon || '', uuid: station.uuid || '', homepage: station.homepage || '' };
    state.error = null; state.loading = true; emit(); persist();
    load(station.url);
    audio.play().catch(() => { state.loading = false; state.error = 'Click play to start (browser blocked autoplay)'; emit(); });
  },
  stop() {
    if (!audio) return;
    audio.pause();
    if (hls) { hls.destroy(); hls = null; }
    audio.removeAttribute('src'); audio.load();
    state.playing = false; state.loading = false; emit();
  },
  toggle() { if (state.playing) radio.stop(); else if (state.station) radio.play(state.station); },
  setVolume(v) { state.volume = Math.max(0, Math.min(1, v)); if (audio) audio.volume = state.volume; persist(); emit(); },
};
